module.exports = __webpack_public_path__ + "img/health2_18-10-2021.3176d148.jpg";